<div class="account"
  *ngIf="{ 
    days: acc.docket?.days_remaining || '0',
    expired: suspended|| acc.docket?.status === 'expired' || acc.docket?.status === 'canceled',
    trial: acc.docket?.status === 'trial',
    trialExpired: acc.docket?.status === 'suspended' && !acc.docket?.stripeId,
    hasPlan: acc.docket?.status && !unplanned_status.includes(acc.docket?.status),
    admin: acc.is_admin,
    leader: acc.is_exec,
    member: acc.is_leader,
    contributor: acc.is_solo,
    remaining: acc.docket?.limit || 0,
    used: acc.docket?.tally || 0
  } as vars"
  [ngClass]="{expired: vars.expired }"
>
  <div class="column title_column">
    <div class="header">
        <photo [data]="acc" [size]="36"></photo>
        <div class="name">{{acc.title}}</div>
    </div>
    <div class="subscription" *ngIf="acc.docket?.status === 'beta'" ><b>Beta account:</b> unlimited events</div>
    <div class="subscription" *ngIf="acc.docket?.status === 'fresh'" ><b>Free trial</b> (starts on event creation)</div>
    <div class="subscription" *ngIf="acc.docket?.status === 'canceled'" >Subscription was cancelled</div>
    <div class="subscription warn" *ngIf="acc.docket?.status === 'incomplete'" ><b>Payment Failed</b> - pending retry</div>
    <div class="subscription" *ngIf="vars.trial" >
      <b>Free trial</b> ({{ vars.days }} day{{ vars.days === '1' ? '' : 's'}} remaining)
      <div class="text_link" *ngIf="vars.admin" (click)="plansPopup(acc.id)">View Plans</div>
    </div>
    <div class="subscription warn" *ngIf="acc.docket?.status === 'suspended' && !acc.docket?.stripeId">
      <b>Account suspended</b> &ndash; free trial expired
      <div class="text_link" *ngIf="vars.admin" (click)="plansPopup(acc.id)">View Plans</div>
    </div>
    <div class="subscription warn" *ngIf="acc.docket?.status === 'suspended' && acc.docket?.stripeId"><b>Account suspended</b> &ndash; check billing details</div>
    <div class="subscription" *ngIf="acc.docket?.status === 'active'">
      <b>{{ vars.remaining }} active event{{ vars.remaining > 1 ? 's' : ''}}</b>
      ({{ acc.docket?.summary }})
    </div>
  </div>
  <div class="column total_count">
    <h5>Current usage:</h5>
    <div class="data">
      <span class="lg">{{vars.used || 0}}</span>
      <span *ngIf="vars.remaining > 0"> of {{vars.remaining}} </span>
      <span>&nbsp;active event{{vars.remaining > 0 ? (vars.remaining !== 1 ? 's' : '') : (vars.used !== 1 ? 's' : '')}}</span>
    </div>
    <div class="percent" *ngIf="vars.remaining > 0 && vars.used > 0">
      <div class="baseline"></div>
      <div class="bar" [ngStyle]="{width: vars.remaining==0 ? 0 : (vars.used/vars.remaining*100 + '%')}"></div>
    </div>
  </div>
  <div class="column members">
    <h5>Members:</h5>
    <div class="data"><span class="lg">{{ acc.users.length }}</span> user{{acc.users.length !==1 ? 's' : ''}}</div>
  </div>
  <div class="column">
    <h5>Permission Level:</h5>
    <div class="data no_lrg_num" *ngIf="vars.admin">Administrator</div>
    <div class="data no_lrg_num" *ngIf="vars.leader">Team Leader</div>
    <div class="data no_lrg_num" *ngIf="vars.member">Team Member</div>
    <div class="data no_lrg_num" *ngIf="vars.contributor">Team Contributor</div>
  </div>
  <div class="column btn plus" *ngIf="!vars.hasPlan && vars.admin">
    <button mat-button color="primary" (click)="plansPopup(acc.id)">Subscribe Now</button>
    <div class="text_link" (click)="visitAccount(acc.id)">Manage &rsaquo;</div>
  </div>
  <div class="column btn" *ngIf="vars.leader || (vars.hasPlan && vars.admin)">
    <button mat-button color="primary" (click)="visitAccount(acc.id)">Manage</button>
  </div>
  <div class="column btn" *ngIf="vars.member || vars.contributor">
    <div [class]="'manage_replacement acc-'+acc.id" [matMenuTriggerFor]="userEdit">
      <icon class="noProfile" matIcon="more_vert"></icon>
    </div>
    <mat-menu #userEdit="matMenu" xPosition="before">
      <button mat-menu-item (click)="removeFromAccount(acc.id, 'acc-'+acc.id)">Leave Account</button>
    </mat-menu>
  </div>
  <mat-progress-bar *ngIf="creating === acc.id" mode="indeterminate"></mat-progress-bar>
</div>